import { css } from "@emotion/react";

export const availabilityNote = css`
  margin-left: 0.25rem;
  gap: 0.25rem;
`;
